import { showCustomerService } from "../vendors";
import Error from "./errors";

export default function NotFound({ error }) {
  return (
    <Error
      title={`404 ${error.message || "Not Found"}`}
      description="We’re sorry, but the page you’re looking for doesn’t seem to exist."
      actionText="Return to application"
      actionHref="/"
    >
      <p className="mb-10 text-sm text-gray-700">
        If you believe this is an error, please{" "}
        <a onClick={showCustomerService} className="underline">
          contact us.
        </a>
      </p>
    </Error>
  );
}
